import React from 'react';
import { useParams } from 'react-router-dom';
import JobSearch from './JobSearch';

const JobSearchWrapper = () => {
	let { filter, job } = useParams(); // Use the useParams hook to access the URL parameter

	if (filter === ':filter' || filter === 'none') { // Check if the parameter is present
		filter = 'none';
		//tidy up the url to remove the :filter
		window.history.replaceState({}, document.title, window.location.pathname.replace('/:filter', '').replace('/none', ''));
	}

	if (job === ':job') { // Check if the parameter is present
		job = 'none';
		//tidy up the url to remove the :filter
		window.history.replaceState({}, document.title, window.location.pathname.replace('/:job', ''));
	}

	window.history.replaceState({}, document.title, window.location.pathname.replace('/none', ''));

	return <JobSearch filter={filter} job={job} />; 
};

export default JobSearchWrapper;